import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { ThemeProvider } from 'styled-components';
import { Button, Logo } from '../../../../components';
import light from '../../../../assets/style/themes/dark';
import * as Message from '../../../../util/messageValidation';
import { Content, ContentWrapper, EmailSendContent, Footer, ImageWrapper, InputField, PageWrapper, } from './styles';
import { ReactComponent as TensaiIcon } from '../../../../assets/images/icons/tensai-logo.svg';
import loginBackground from '../../../../assets/images/login-background.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { resetEmail } from 'src/stores/actions/recoverPassword';
import { useDispatch } from 'react-redux';

/**
 * Create validation scheme
 */
const schema = yup.object().shape({
  login: yup.string().email(Message.emailValid).required(Message.required).max(70, 'O campo não pode ter mais que 70 caracteres'),
});


export default function EmailFormCard({ handleSubmit, running, emailSent }) {
  const theme = light;

  const history = useHistory();
  const dispatch = useDispatch();

  const [userEmail, setUserEmail] = useState('');

  function goToLogin() {
    resetEmail(dispatch);
    history.goBack();
  }

  // initial values
  const initialValues = {
    login: '',
  };
  
  function onSubmit(values) {
    setUserEmail(values.login)
    handleSubmit(values.login);
  }

  return (
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <ContentWrapper>
          { !emailSent
          ? <Content>
              <Logo />
              <h1>Recuperar senha</h1>
              <h3>Informe o seu e-mail de cadastro para enviarmos o link de recuperação</h3>
              <Formik
                onSubmit={onSubmit}
                initialValues={initialValues}
                validationSchema={schema}
              >
                {({ isValid, errors, values }) => (
                  <Form className="form">
                    <InputField isValid={!errors.login}>
                      <Field 
                        name="login" 
                        type="login" 
                        placeholder="Informe o seu e-mail"
                      />

                      <ErrorMessage name="login">
                        {(msg) => <span className="errorMessage">{msg}</span>}
                      </ErrorMessage>

                    </InputField>
                    <div className="action">
                      <Button 
                        title={'Enviar'} 
                        type="submit" 
                        loading={running}
                        disable={!isValid || !values.login}
                      />
                    </div>
                    <div className='cancel'>
                      <button
                        type='button'
                        onClick={goToLogin}
                      >Cancelar</button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Content>
          : <EmailSendContent>
              <Logo />
              <h1>Recuperar senha</h1>
              <h3>Um e-mail de recuperação de senha foi enviado para { userEmail }!</h3>
              <div className='action'>
                <Button 
                  title={'Voltar'}
                  onClick={goToLogin}
                />
              </div>
            </EmailSendContent>
          }
          <Footer>
            <div className="copyright">
              <TensaiIcon />
              <span> Distribuído por &copy; 2019 Tensai. Todos os direitos reservados</span>
            </div>
          </Footer>
        </ContentWrapper>
        <ImageWrapper>
          <img src={loginBackground} />
        </ImageWrapper>
      </PageWrapper>
    </ThemeProvider>
  );
}
